import React from "react";

const Close = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20.7409" height="1.88553" transform="matrix(0.707075 0.707138 -0.707075 0.707138 1.33594 0)" fill="white"/>
<rect width="20.7409" height="1.88553" transform="matrix(-0.707075 0.707138 0.707075 0.707138 14.6641 0)" fill="white"/>
</svg>
);

export default Close;
